export const DEFAULT_DISCORD_VOICE_SYNTHESIS_SETTINGS = {
  speed: 1,
  volume: 0,
  normalize_loudness: true,
  temperature: 0.7,
  top_p: 0.7,
  normalize: true,
  latency: "normal",
} as const;

export interface DiscordVoiceSynthesisSettings {
  speed: number;
  volume: number;
  normalize_loudness: boolean;
  temperature: number;
  top_p: number;
  normalize: boolean;
  latency: "normal" | "balanced" | "low";
}

export function parseDiscordVoiceSynthesisSettings(value: unknown): DiscordVoiceSynthesisSettings | null {
  if (value === null) return null;
  if (typeof value !== "object" || Array.isArray(value)) return null;
  const item = value as Record<string, unknown>;
  const keys = Object.keys(DEFAULT_DISCORD_VOICE_SYNTHESIS_SETTINGS);
  if (Object.keys(item).length !== keys.length || keys.some((key) => !(key in item))) return null;
  if (typeof item.speed !== "number" || !Number.isFinite(item.speed) || item.speed < 0.5 || item.speed > 2) return null;
  if (typeof item.volume !== "number" || !Number.isFinite(item.volume) || item.volume < -20 || item.volume > 20) return null;
  if (typeof item.normalize_loudness !== "boolean" || typeof item.normalize !== "boolean") return null;
  if (typeof item.temperature !== "number" || !Number.isFinite(item.temperature) || item.temperature < 0 || item.temperature > 1) return null;
  if (typeof item.top_p !== "number" || !Number.isFinite(item.top_p) || item.top_p < 0 || item.top_p > 1) return null;
  if (item.latency !== "normal" && item.latency !== "balanced" && item.latency !== "low") return null;
  return { speed: item.speed, volume: item.volume, normalize_loudness: item.normalize_loudness, temperature: item.temperature, top_p: item.top_p, normalize: item.normalize, latency: item.latency };
}

export function mergeDiscordVoiceSynthesisSettings(value: unknown): DiscordVoiceSynthesisSettings {
  return parseDiscordVoiceSynthesisSettings(value) ?? { ...DEFAULT_DISCORD_VOICE_SYNTHESIS_SETTINGS };
}
